import {BehaviorSubject} from 'rxjs';

export enum Draggables {
    Sprint = 'sprint',
    CreateSprintButton = 'create-sprint-button',
}

export interface DraggedSprint {
    type: Draggables.Sprint;
    id: number;
}

export interface DraggedCreateSprintButton {
    type: Draggables.CreateSprintButton;
    employeeId: number;
    from: Date;
    till: Date | null;
}

export type Draggable = DraggedSprint | DraggedCreateSprintButton;

export class DragContext {
    public currentlyDraggedUpdates = new BehaviorSubject<Draggable | null>(null);

    public get currentlyDragged(): Draggable | null {
        return this.currentlyDraggedUpdates.value;
    }

    public register(draggable: Draggable) {
        this.currentlyDraggedUpdates.next(draggable);
    }

    public clear() {
        this.currentlyDraggedUpdates.next(null);
    }
}
